@if (watchlistItems && fairsConfig) {
<div class="result-list">
  @for (watchlistItem of watchlistItems; track identifyWatchlistItem($index, watchlistItem)) { @if (watchlistItem.data
  || watchlistItem.deleted) { @if (fairsConfig.fairs[watchlistItem.fair_id]; as fair) {
  <bau365-watchlist-item
    class="result-item"
    [item]="watchlistItem"
    [fair]="fair"
    [itemType]="getItemType(watchlistItem)"
    [screen]="screen"
    (deleteItem)="onDeleteItem($event)"
    (shareItemAction)="onShareItemAction($event.network, $event.item)"
    (shareItem)="onShareItem($event)"></bau365-watchlist-item>
  } } }
</div>
}
